import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';


/**
 * APIL Url: ADAC.Internet.Core.Models.Fahrzeugdaten.FahrzeugscheinValue
 * Fahrzeugscheindaten
 * Endpoints: /api/Garage/{id}, /api/Garage
 */
export class FahrzeugscheinValueApi extends BaseApiModel {
	constructor(initialProperties?: Partial<FahrzeugscheinValueApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected fahrzeugscheinKey: string;
	/**
	 * Description: Name im Fahrzeugschein
	 * APIL Type: string
	 */
	get FahrzeugscheinKey(): string {
		return this.fahrzeugscheinKey;
	}

	/**
	 * Description: Name im Fahrzeugschein
	 * APIL Type: string
	 */
	set FahrzeugscheinKey(value: string) {
		this.fahrzeugscheinKey = value;
	}

	protected value: string;
	/**
	 * Description: Wert
	 * APIL Type: string
	 */
	get Value(): string {
		return this.value;
	}

	/**
	 * Description: Wert
	 * APIL Type: string
	 */
	set Value(value: string) {
		this.value = value;
	}

	protected probability: number;
	/**
	 * Description: Genauigkeit des Scans
	 * APIL Type: double
	 */
	get Probability(): number {
		return this.probability;
	}

	/**
	 * Description: Genauigkeit des Scans
	 * APIL Type: double
	 */
	set Probability(value: number) {
		this.probability = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): FahrzeugscheinValueApi {
		return AppUtils.Helper.createFromMap(dataObject, FahrzeugscheinValueApi, (key, value) => {
			switch (key.toLowerCase()) {

				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		result.FahrzeugscheinKey = this.fahrzeugscheinKey;
		result.Value = this.value;
		result.Probability = this.probability;
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}